import React, { useContext, useEffect, useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Box } from "@mui/material";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { EfetivoPecuarioEFGH1, } from "./efetivopecuario";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import EficienciaAlimentarViewTecnico from "../../../Styles/layout/eficienciaAlimentarView";
import { IAlimento, IEfetivoPecuarioGH1, INecessidadesDia, INecessidadesTotais } from "../../../Interfaces/eficiencia_alimentar/planoAlimentar_GrupoHomo";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { IGrupos_Homo_Eficiencia_Alimentar } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { NecessidadesNutriEFGH1 } from "./NecessidadeDia";
import { NecessidadesNutricionaisTotais } from "./necessidades_totais";
import { AlimentoCompostoGH } from "./alimento_composto_GH";
import { get } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { CabecalhoForm } from "./cabecalho";
import { somaOitoCampos } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },

    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
  })
);



export default function EF_PA_GH1() {
  const classes = useStyles();
  const auth = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IGrupos_Homo_Eficiencia_Alimentar>();

  const [efetivo, setEfetivo] = useState<IEfetivoPecuarioGH1>();

  const [necessidades_dia, set_necessidades_dia] = useState<INecessidadesDia>();

  const [necessidades_total, set_necessidades_total] = useState<INecessidadesTotais>();

  const [alimento, set_alimento] = useState<IAlimento>();

  async function getTabela(idCabecalho: number) {
    try {

      if (idCabecalho !== undefined && idCabecalho !== 0) {
        let res = await get(auth.token.cookie_token, `/get_all_PA_GH_by_IdGrupo/${idCabecalho}`);
        if (res.status === 200) {

          if (res.data.result[0].length > 0) {
            setEfetivo(res.data.result[0][0])
          } else {
            setEfetivo(undefined);
          }

          if (res.data.result[1].length > 0) {
            set_necessidades_dia(res.data.result[1][0]);
          } else {
            set_necessidades_dia(undefined);
          }

          if (res.data.result[2].length > 0) {
            set_necessidades_total(res.data.result[2][0]);
          } else {
            set_necessidades_total(undefined);
          }

          if (res.data.result[3].length > 0) {
            set_alimento(res.data.result[3][0]);
          } else {
            set_alimento(undefined);
          }

        }
      };
      setIsLoading(false);

    } catch (error) {
      func_print("getTabela", error, true);
      setIsLoading(false);
    }
  };



  useEffect(() => {
    (async () => {
      if (especie_ou_lote_homegenio_selecionada !== undefined) {
        await getTabela(especie_ou_lote_homegenio_selecionada.id_grupo);
      }
    })();
  }, [especie_ou_lote_homegenio_selecionada]);


  return (
    <div className={classes.root}>
      <EficienciaAlimentarViewTecnico title="Plano Alimentar Grupo Homogéneo" />
      <main className={classes.contents}>
        <div className={classes.toolbars} />

        <Box width="80%" margin="auto">
          <BeneficiarioNomeIdAlinhadoDireita />
        </Box>
        <CabecalhoForm
          especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada}
          set_especie_ou_lote_homegenio_selecionada={set_especie_ou_lote_homegenio_selecionada}
          setIsLoading={setIsLoading}
        ></CabecalhoForm>
        {isLoading ?
          <LoadingVulpes />
          :
          especie_ou_lote_homegenio_selecionada === undefined ? <></> :
            <CustomThemeProvider>
              <EfetivoPecuarioEFGH1
                tabela={efetivo}
                setTabela={setEfetivo}
                set_necessidades_dia={set_necessidades_dia}
                set_necessidades_total={set_necessidades_total}
                especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada}
              />

              <NecessidadesNutriEFGH1
                tabela={necessidades_dia}
                setTabela={set_necessidades_dia}
                set_necessidades_total={set_necessidades_total}
                especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada}
                alimento={alimento}
                set_alimento={set_alimento}

              />

              <NecessidadesNutricionaisTotais
                tabela={necessidades_total}
                setTabela={set_necessidades_total}
                necessidades_dia={necessidades_dia}
                isLoading={isLoading}
              />

              <AlimentoCompostoGH
                alimento_composto_1={necessidades_total?.camp_1_alimento_composto}
                alimento_composto_2={necessidades_total?.camp_2_alimento_composto}
                alimento_composto_3={necessidades_total?.camp_3_alimento_composto}
                alimento_composto_4={necessidades_total?.camp_4_alimento_composto}
                alimento_composto_5={necessidades_total?.camp_5_alimento_composto}
                alimento_composto_6={necessidades_total?.camp_6_alimento_composto}
                alimento_composto_7={necessidades_total?.camp_7_alimento_composto}
                alimento_composto_8={necessidades_total?.camp_8_alimento_composto}
                alimento_composto_total={somaOitoCampos(desformatarNumero(necessidades_total?.camp_1_alimento_composto), desformatarNumero(necessidades_total?.camp_2_alimento_composto), desformatarNumero(necessidades_total?.camp_3_alimento_composto), desformatarNumero(necessidades_total?.camp_4_alimento_composto), desformatarNumero(necessidades_total?.camp_5_alimento_composto), desformatarNumero(necessidades_total?.camp_6_alimento_composto), desformatarNumero(necessidades_total?.camp_7_alimento_composto), desformatarNumero(necessidades_total?.camp_8_alimento_composto))}
                tabela={alimento}
                setTabela={set_alimento}
                especie_ou_lote_homegenio_selecionada={especie_ou_lote_homegenio_selecionada}
                set_necessidades_dia={set_necessidades_dia}


              />


            </CustomThemeProvider>
        }
      </main>
    </div>
  );
}
